import { createDecorator } from '../../instantiation/common/instantiation.js';
const IExtensionStorageService = ( createDecorator('IExtensionStorageService'));
export { IExtensionStorageService };
